// extracted by mini-css-extract-plugin
export default {"Children":"LabeledInput_Children__6Z6gE","SubLabel":"LabeledInput_SubLabel__EzF09"};